import { useAppSelector } from '../store'

export function useAppLoading() {
  return useAppSelector(state => Object.values(state.ReservationWidgetAPI.queries).some(query => query?.status === 'pending'))
}
